import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BroadcastService } from "src/app/services/core/broadcast/broadcast.service";
import { ConfigurationSettings } from "src/app/models/configuration.settings";
import { ToasterService } from "../../../services/shared/toaster/toaster.service";
import { IBroadcast, IBroadcastBotInfo } from "src/app/models/broadcast";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { IUserRoleDetails } from "src/app/models/user-role-details";
import { WarningPopupComponent } from "../../shared/warning-popup/warning-popup.component";
import { MatDialog } from "@angular/material";

@Component({
  selector: "app-broadcastactions",
  templateUrl: "./broadcastactions.component.html",
  styleUrls: ["./broadcastactions.component.scss"],
})
export class BroadcastactionsComponent implements OnInit {
  private _subscriptions = new Subscription();
  broadcastData: IBroadcast;
  recipients: string[] = [];
  isActive: boolean = false;
  isManual: boolean = false;
  broadcastBotInfo: IBroadcastBotInfo;
  botConfigId: number;
  broadcastId: number;
  modalHeader: string;
  modalBody: string;
  isActivate: boolean = false;
  isTrigger: boolean = false;
  showDeactivate: boolean = false;
  showTrigger: boolean = false;
  showActivate: boolean = false;
  showSchedule: boolean = false;
  isScheduled: boolean = false;
 

  private userRoleDetails: IUserRoleDetails[] = [];
  constructor(
    private toasterService: ToasterService,
    private broadcastService: BroadcastService,
    private router: Router,
    private dialogWarning: MatDialog
  ) {}

  ngOnInit() {
    this.broadcastData = JSON.parse(sessionStorage.getItem("broadcastData"));
    this.broadcastBotInfo = JSON.parse(sessionStorage.getItem("broadcastBotInfo"));
    this.botConfigId = this.broadcastData.botConfigId;
    this.broadcastId = this.broadcastData.id;
    this.recipients = this.broadcastData.recipients.split(",");
    this.isActive = this.broadcastData.status == "Active" ? true : false;
    this.isManual = this.broadcastData.triggerMode == "Manual" ? true : false;
    
  }
  BroadcastCancel() {
    this.router.navigate(["utility/broadcast"], {
      queryParams: { id: this.broadcastData.botConfigId },
    });
  }
  //Activate Broadcast
  OnActivateBroadcast() {
    let allowAction = this.checkRoleForAction(this.botConfigId);
    if (allowAction) {
      this._subscriptions.add(
        this.broadcastService.ActivateBroadcast(this.broadcastId).subscribe(
          (res) => {
            this.toasterService.success("Broadcast Activated successfully!!");
            this.broadcastData.status = "Active";
            this.isActive = true;
          },
          (error) => {
            console.log(error);
          }
        )
      );
    } else {
      this.toasterService.error(
        "You are not authorized to activate broadcast for this BOT!"
      );
    }
  }
  
  checkRoleForAction(selectedbotConfigId: number) {
    this.userRoleDetails = JSON.parse(sessionStorage.getItem("userBotRoles"));
    let botConfigId = this.userRoleDetails.filter(
      (x) =>
        (x.botConfigId == selectedbotConfigId || x.botConfigId == 0) &&
        (x.role.toLowerCase() == "chatbot admin" ||
          x.role.toLowerCase() == "chatbotadmin" ||
          x.role.toLowerCase() == "super admin" ||
          x.role.toLowerCase() == "superadmin")
    );
    if (botConfigId && botConfigId.length > 0) return true;
    else return false;
  }
  SetModalContent(sender: string) {
    switch (sender) {
      case "activate":
        this.modalHeader = "Confirm Broadcast Activation";
        this.modalBody =
          " Do you want to Preview and Activate this Broadcast?";
        this.showTrigger = false;
        this.showDeactivate = false;
        this.showActivate = true;
        this.showSchedule = false;
        break;
      case "deactivate":
        this.modalHeader = "Confirm Broadcast Deactivation";
        this.modalBody = " Do you want to deactivate this Broadcast?";
        this.showTrigger = false;
        this.showDeactivate = true;
        this.showActivate = false;
        this.showSchedule = false;
        break;
      case "trigger":
        this.modalHeader = "Confirm Broadcast Trigger";
        this.modalBody = " Do you want to initiate this broadcast?";
        this.showTrigger = true;
        this.showDeactivate = false;
        this.showActivate = false;
        this.showSchedule = false;
        break;
      case "schedule":
        this.modalHeader = "Confirm Broadcast Schedule";
        this.modalBody = " Do you want to schedule this Broadcast?";
        this.showTrigger = false;
        this.showDeactivate = false;
        this.showActivate = false;
        this.showSchedule = true;
        break;
    }
  }

  OnTriggerBroadcast() {
    let allowAction = this.checkRoleForAction(this.botConfigId);
    if (allowAction) {
      this._subscriptions.add(
        this.broadcastService.TriggerBroadcast(this.broadcastId).subscribe(
          (res) => {
            this.toasterService.success("Broadcast Initiated successfully!!");
          },
          (error) => {
            console.log(error);
          }
        )
      );
    } else {
      this.toasterService.error(
        "You are not authorized to initiate broadcast for this BOT!"
      );
    }
  }
  OnDeactivateBroadcast() {
    let allowAction = this.checkRoleForAction(this.botConfigId);
    if (allowAction) {
      this._subscriptions.add(
        this.broadcastService.DectivateBroadcast(this.broadcastId).subscribe(
          (res) => {
            this.toasterService.success("Broadcast Deactivated successfully!!");
            this.broadcastData.status = "Inactive";
            this.isActive = false;
          },
          (error) => {
            console.log(error);
          }
        )
      );
    } else {
      this.toasterService.error(
        "You are not authorized to deactivate broadcast for this BOT!"
      );
    }
  }

  OnScheduleBroadcast() {
    let allowAction = this.checkRoleForAction(this.botConfigId);
    if (allowAction) {
      this._subscriptions.add(
        this.broadcastService.ScheduleBroadcast(this.broadcastId).subscribe(
          (res) => {
            this.toasterService.success("Broadcast Scheduled successfully!!");
            this.isScheduled = true;
          },
          (error) => {
            console.log(error);
          }
        )
      );
    } else {
      this.toasterService.error(
        "You are not authorized to schedule broadcast for this BOT!"
      );
    }
  }
}
